import React from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import { AccountOpeningTrustAddressLayout } from 'Views/Page/Content/Templates/AccountOpeningTrustAddressStep/layout';

const metaOverrideSet = fr.metaOverride({ base: BaseWizardStepOverride });

const AccountOpeningTrustAddress = ({ resource }) => {
  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={AccountOpeningTrustAddressLayout}
      LayoutProps={{
        resource,
      }}
      primaryActionLabel={resource.attr('primaryActionLabel') || undefined}
    />
  );
};

AccountOpeningTrustAddress.defaultProps = {
};

AccountOpeningTrustAddress.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AccountOpeningTrustAddress;
